module.exports = __webpack_public_path__ + "static/media/review.0747c131.jpg";